/**
 * CurrencySelect Component
 */

import { getCurrencyOptions } from '../../../../redux/selectors/staticData';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { FormProps, reduxForm } from 'redux-form';

import { CurrencyContext } from '../../../../contexts/currency';
import { ICurrencyContext } from '../../../../contexts/currency/types';
import Select, { ISelectProps } from './';

interface IOwnStateProps extends Pick<CurrencySelectProps, 'initialValues'> {
  currencyOptions: Array<{
    value: AcceptedCurrency;
    label: string;
  }>;
}

interface IOwnProps {
  className?: string;
  selectProps?: Partial<ISelectProps>;
}

type CurrencySelectProps =
  & IOwnProps
  & IOwnStateProps
  & FormProps<any, any, any>
  & ICurrencyContext;

const classes = new BEM('currency-select');
const form = 'currency-select';

class CurrencySelect extends React.Component<CurrencySelectProps> {
  onSetCurrency = ({ value }: ISelectStoreItem) => {
    this.props.setCurrency(value as GQL.Currency);
  }

  render() {
    return (
      <form {...classes('', '', this.props.className)}>
        <Select
          form={form}
          name="currencySelect"
          onUpdate={this.onSetCurrency}
          options={this.props.currencyOptions}
          updateOnMount={false}
          selectName="currency-select"
          selectProps={{
            autoBlur: true,
            clearable: false,
            searchable: false,
          }}
          size="small"
          {...this.props.selectProps}
        />
      </form>
    );
  }
}

const CurrencySelectForm = reduxForm({
  form,
})(CurrencySelect);

const ConnectedCurrencySelect = connect<IOwnStateProps, {}, IOwnProps & ICurrencyContext, IStoreState>(
  (state, ownProps) => ({
    initialValues: {
      currencySelect: ownProps.currency,
    },
    currencyOptions: getCurrencyOptions(state),
  }),
)(CurrencySelectForm);

const CurrencySelectWithContext: React.SFC<IOwnProps> = (props) => (
  <CurrencyContext.Consumer>
    {(ctx) => <ConnectedCurrencySelect {...ctx} {...props} />}
  </CurrencyContext.Consumer>
);

export default CurrencySelectWithContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/Select/CurrencySelect.tsx